import React, { useEffect, useState } from 'react';
import { getActiveTariffConfig, DEFAULT_CONFIG } from '../DELIVERY/utils/tarifaCalculator';
import { FaPercentage } from 'react-icons/fa';

const DriverCommissionInfo = () => {
    const [pct, setPct] = useState(DEFAULT_CONFIG.platform_commission);

    useEffect(() => {
        let mounted = true;
        getActiveTariffConfig()
            .then(cfg => { if (mounted) setPct((cfg && cfg.platform_commission) || DEFAULT_CONFIG.platform_commission); })
            .catch(() => {});
        return () => { mounted = false; };
    }, []);

    return (
        <div 
            data-testid="driver-commission-info" 
            className="dv-gps-toggle-row mb-3 shadow-sm"
            style={{ minHeight: '68px' }}
        >
            <div className="d-flex align-items-center gap-3">
                <div 
                    className="rounded-circle d-flex align-items-center justify-content-center"
                    style={{
                        width: '38px',
                        height: '38px',
                        backgroundColor: 'rgba(14, 171, 176, 0.15)',
                        color: 'var(--bry-accent, #0EABB0)',
                        border: '1px solid rgba(14, 171, 176, 0.35)'
                    }}
                >
                    <FaPercentage size={16} />
                </div>
                <div>
                    <div className="dv-gps-label" style={{ letterSpacing: '0.5px' }}>
                        TU COMISIÓN DE PLATAFORMA
                    </div>
                    <div className="dv-gps-sublabel text-muted" style={{ fontSize: '11px' }}>
                        Fija por servicio · Cobras el monto neto garantizado
                    </div>
                </div>
            </div>
            <div className="text-end">
                <span 
                    data-testid="driver-commission-pct" 
                    className="fw-bold px-3 py-1 rounded-pill"
                    style={{ 
                        fontSize: '15px', 
                        backgroundColor: 'rgba(14, 171, 176, 0.15)', 
                        color: 'var(--bry-accent, #0EABB0)',
                        border: '1px solid var(--bry-accent, #0EABB0)'
                    }}
                >
                    {pct}%
                </span>
            </div>
        </div>
    );
};

export default DriverCommissionInfo;
